import { getPagintaionModuleState } from '@/helpers/store-state'
import { State } from './types'

export const getInitialState = (): State => ({
  listModule: getPagintaionModuleState(),
})
